export default function calcMaxConvMiLtv(state){
    if(state=="TX"){
        return 75
    }
    else return 87
}